
import spritesheet from '../icons/spritesheet-simbologia-old.png';

export default {
    sprite: {
        backgroundImage: `url(${ spritesheet })`,
        backgroundRepeat: 'no-repeat',
        display: 'block',
      }, 
  
    sprite301: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -5px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite304: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -267px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite307: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -529px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite400: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -796px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite401: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -1058px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite403: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -1320px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite404: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -1582px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite405: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -1844px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite406: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -2106px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite407: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -2368px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite408: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -2630px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite409: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -2892px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite410: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -3154px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite411: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -3416px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite412: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -3678px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite413: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -3940px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite414: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -4202px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite415: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -4464px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite416: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -4726px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite417: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -4988px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite439: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -5250px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite500: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -5512px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite501: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -5774px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite502: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -6036px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite503: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -6298px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite504: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -6560px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite505: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -6820px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite520: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -7080px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite521: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -7340px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    sprite522: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -7600px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    spriteCAMPO_NO_DISPONIBLE: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -7860px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    spriteCERTIFICADO_INVALIDO: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -8120px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    spriteCONEXION_RECHAZADA: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -8380px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    spriteDOWNTIME_FUNCIONAL: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -8640px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    spriteELEMENTO_DEL_SERVIDOR_NO_ENCONTRADO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -8900px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteELEMENTO_EXCLUIDO: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -9160px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_400: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -9422px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_401: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -9682px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_403: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -9942px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_404: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -10202px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_AUTENTICACION: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -10462px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_CONEXION_MAILBOX: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -10722px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_CONFIGURACION: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -10982px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_CONTENIDO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -11242px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_CONTENIDO_CONOCIDO_DNS: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -11502px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_CONTENIDO_DNS: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -11762px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_CORREO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -12022px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_DE_RED_DESCONOCIDO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -12282px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_DESCONOCIDO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -12542px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_DESCONOCIDO_EN_SCRIPT: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -12802px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_DESCONOCIDO_IVR: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -13062px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_DESCONOCIDO_IVR_9999: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -13322px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_PATRON_DE_IMAGEN: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -13582px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_PATRON_IMAGEN_INVERSO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -13842px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_PATRON_OCR: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -14102px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_PATRON_TOKEN: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -14362px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_RECEPCION_MAIL: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -14622px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_SMTP: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -14882px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteERROR_SOAP: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -15142px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteFALTARON_ELEMENTOS: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -15402px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteLLAMADA_COLGADA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -15662px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteLLAMADA_ERROR_DE_CONTENIDO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -15922px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteLLAMADA_NO_CONTESTADA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -16182px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteMAIL_OK: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -16442px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteNO_MONITOREO: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -16704px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'       
    },
    
    spriteOK: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -16966px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOK_200: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -17226px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOK_204: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -17486px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOK_AL_SEGUNDO_INTENTO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -17746px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOK_DNS: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -18006px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOK_DNS_NoAutoritativo: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -18266px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOPERADOR_NO_CONTESTO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -18526px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteOPERADOR_OK: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -18786px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spritePATRON_DE_ERROR_ENCONTRADO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -19048px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spritePETICION_CANCELADA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -19308px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteREDIRECCIONANDO_302: {
        width: '292px',
        height: '254px',
        backgroundPosition: '-5px -19568px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSERVIDOR_CERRO_CONEXION: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -19832px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSERVIDOR_CORREO_OK: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -20092px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSERVIDOR_NO_ENCONTRADO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -20354px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSERVIDOR_SIN_RESPUESTA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -20614px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSIN_DOMINIO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -20874px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSIN_MEDICION: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -21134px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSIN_NOMBRE: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -21394px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSIN_REPSUESTA_DESDE_ISP: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -21654px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSIN_RESPUESTA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -21914px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteSIN_SERVIDOR: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -22174px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTEXTO_VACIO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -22434px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -22694px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_CORREO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -22954px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_DE_LA_OPERACION_DEL_SOCKET: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -23214px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_EN_CONEXION: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -23474px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_INFINITO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -23734px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_JS: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -23994px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_LLAMADA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -24254px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTIMEOUT_PAGINA: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -24514px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTRONCAL_CONGESTIONADO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -24774px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteTRONCAL_OCUPADO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -25034px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spriteURL_NORESUELTO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -25294px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },
    
    spritePeriodo_Marcado: {
        width: '286px',
        height: '252px',
        backgroundPosition: '-5px -25554px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    },

    spriteERROR_PATRON_OCR_INVERSO: {
        width: '292px',
        height: '250px',
        backgroundPosition: '-5px -25814px',
        zoom: '30%',
        scale:"0.3",
        transform:'scale(0.5)', 
        transformOrigin:'left top 0px'
    }
}